import { Component, OnInit } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';
import { ConstantData } from 'src/app/services/constants';
import { SnackbarData } from 'src/app/services/model';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-snackbar',
  templateUrl: './snackbar.component.html',
  styleUrls: ['./snackbar.component.scss']
})
export class SnackbarComponent {
  snackbarArrow:AnimationOptions = {
    path:this.util.redirectionUrl + ConstantData.snackbarArrow,
  };
  snackbarIcon:AnimationOptions = {
    path: this.util.redirectionUrl + ConstantData.snackbarIcon,
  };
  timerInterval: any;
  loadingTimer:any;
  showLoader:boolean = false;
  get isMobile(){
    return this.util.isMobile;
  }

  get product() {
    return this.util.getCache('productCat');
  }
  get title() {
    return this.product?.name || '';
  }
  get icon() {
    return this.util.getImageFromBase64(this.product?.image64);
  }

  get sanckbarData(): SnackbarData | null {
    return this.util.getsanckbarStatus();
  }
  timer: any;
  constructor(private util: UtilService) {

    this.timer = setInterval(() => {
      if (this.sanckbarData) {
        this.updateStatus();
        clearInterval(this.timer);
      }
    }, 2000);

  }
   isTextOverflowed(element:any) {
    return element.scrollWidth > element.clientWidth;
  }

  updateStatus() {
    if (this.sanckbarData?.isRepeat) {
      if(!this.loadingTimer)
      this.loadingTimer = setInterval(()=>{
          this.showLoader = !this.showLoader;  
      },5000);
      this.util.getProducts(undefined, false).then(() => {
        setTimeout(() => {
          this.updateStatus();
        }, 5000);
      })

    }else{
      this.showLoader = false;
      clearInterval(this.loadingTimer);
    }
  }



}
